import { DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMappingControl extends Layout {
    sourceMappingControl: DataSource;
    switchShowMaps: Switch;
    textboxDistanceCalcVendor: Textbox;
    textboxFindnearVendor: Textbox;
    textboxMovementMapVendor: Textbox;
    textboxPartialShipmentVendor: Textbox;
    textboxRequestLocationVendor: Textbox;
    textboxSinglePointVendor: Textbox;
    textboxWebMap: Textbox;
    textboxZoneMappingVendor: Textbox;
}
